/*
 * Copyright (c) 2023 Helvia Technologies PC <contact@helvia.io>
 */
import { HTMLProps, ReactNode } from "react";

interface ContainerProps extends HTMLProps<HTMLDivElement> {
  fluid?: boolean;
  className?: string;
  children?: ReactNode;
}

/**
 * Custom Container component
 * @param fluid {boolean} should the container be 100% width or not
 * @param props rest of the props
 * @returns {JSX.Element}
 */
export const Container = ({ fluid, className, ...props }: ContainerProps): JSX.Element => {
  const containerClass = fluid ? "container-fluid" : "container";
  return <div className={`${className || ""} ${containerClass}`} {...props} />;
};
